import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@awesome.me/kit-70c1f0055f/icons/classic/regular";
import { GlobalSearchDialog } from "./GlobalSearchDialog";
import { useGlobalSearch } from "@/hooks/useGlobalSearch";
import { useSearchKeyboardShortcuts } from "@/hooks/useSearchKeyboardShortcuts";
import { usePlatform } from "@/hooks/usePlatform";

interface GlobalSearchButtonProps {
  className?: string;
  collapsed?: boolean;
}

export function GlobalSearchButton({
  className = "",
  collapsed = false,
}: GlobalSearchButtonProps) {
  const { isSearchOpen, openSearch, closeSearch } = useGlobalSearch();
  const { isMac } = usePlatform();

  useSearchKeyboardShortcuts({ isSearchOpen, openSearch, closeSearch });

  const handleSearchClick = () => {
    openSearch();
  };

  return (
    <>
      <button
        onClick={handleSearchClick}
        className={`flex min-h-[32px] items-center gap-3 rounded-lg px-2.5 text-slate-600 transition-colors group hover:bg-slate-200/80 hover:text-slate-900 dark:text-white/60 dark:hover:bg-slate-900/30 dark:hover:text-white ${className}`}
        title="Global Search"
      >
        <div className="flex-shrink-0 relative w-5 self-center flex items-center justify-center">
          <FontAwesomeIcon icon={faSearch} fixedWidth />
        </div>
        {!collapsed && (
          <div className="flex items-center justify-between gap-2 w-full">
            <span className="font-medium">Search</span>
            <div className="flex items-center gap-1 text-xs text-slate-400 dark:text-white/40">
              <div
                className={`${
                  isMac ? "aspect-square" : "px-1.5"
                } flex h-[16px] items-center justify-center rounded bg-slate-200 text-[10px] leading-none dark:bg-white/10`}
              >
                {isMac ? "⌘" : "Ctrl"}
              </div>
              <div
                className="flex aspect-square w-[16px] items-center justify-center rounded bg-slate-200 text-[10px] leading-none dark:bg-white/10"
              >
                K
              </div>
            </div>
          </div>
        )}
      </button>

      <GlobalSearchDialog isOpen={isSearchOpen} onClose={closeSearch} />
    </>
  );
}
